import { apiClient } from '@/hooks/useAxios';
import { CommonRes, Profile } from '@/types';

const ApiPath = '/user';

export const fetchProfile = async (): Promise<CommonRes<Profile>> => {
  const res = await apiClient.get<CommonRes<Profile>>(`${ApiPath}`);
  return res.data;
};

export const updateProfile = async (payload: {
  name?: string;
  avatarUrl?: string;
}): Promise<CommonRes<Profile>> => {
  const res = await apiClient.put<CommonRes<Profile>>(`${ApiPath}`, payload);
  return res.data;
};
